<template>
    <div>    
        <main class="d-flex justify-content-center inicio-home">
            <div class="container p-5">
                <div class="row d-flex justify-content-center"> 
                    <div class="col-md-8  bg-body rounded shadow-sm p-5" v-if="!isLoad">
                      <h1 class="text-center">Editar perfil</h1>
                        <br> 
                      <div  class="cargando"></div>  
                    </div>                
                    <div class="col-md-8  bg-body rounded shadow-sm p-5" v-if="formulario == 1 && isLoad">
                      <form @submit.prevent="submit1">
                       <h1 class="text-center">Editar perfil</h1>
                       <br>

                       <div class="col-md-12">
                        <label for="firstName" class="form-label">Celular *</label>
                        <input type="text" class="form-control" id="firstName" placeholder="" v-model="registerForm.DatosPersonales.Celular" @keypress="soloNumeros" required>
                      </div>
                      
                      <div class="col-md-12 m-t-2">
                        <label for="Nacionalidad" class="form-label">País de residencia *</label>  
                        <select class="form-select" aria-label="Default select example" id="Nacionalidad" name="Nacionalidad" v-model="registerForm.DatosPersonales.PaisResidencia" @change="obtenerSelectDepartamento" required>
                          <option v-for="(linea,index) in selectPais" :key="index" :value="linea.IdPais" v-text="linea.NombrePais" ></option>
                        </select>
                      </div>
                      <div v-if="registerForm.DatosPersonales.PaisResidencia=='200'">
                      <div class="col-md-12 m-t-2">
                        <label for="firstName" class="form-label">Departamento *</label>
                        <select class="form-select" id="Departamento" name="Departamento" aria-label="Default select example" v-model="registerForm.DatosPersonales.Departamento" @change="obtenerSelectProvincia"  required>
                          <option v-for="(linea,index) in selectDepartamento" :key="index" :value="linea.IdDepartamento" v-text="linea.NombreDepartamento" ></option>
                        </select>
                     </div>
                    
                      <div class="col-md-12 m-t-2">
                          <label for="firstName" class="form-label">Provincia</label>
                          <select class="form-select" id="Provincia" name="Provincia" aria-label="Default select example" v-model="registerForm.DatosPersonales.Provincia" @change="obtenerSelectDistrito" required>
                            <option v-for="(linea,index) in selectProvincia" :key="index" :value="linea.IdProvincia" v-text="linea.NombreProvincia" ></option>
                          </select>
                      </div>
                    
                      <div class="col-md-12 m-t-2">
                          <label for="firstName" class="form-label">Distrito</label>
                          <select class="form-select" id="Distrito" name="Distrito" aria-label="Default select example" v-model="registerForm.DatosPersonales.Distrito" required>
                            <option v-for="(linea,index) in selectDistrito" :key="index" :value="linea.Ubigeo" v-text="linea.NombreDistrito" ></option>
                          </select>
                      </div>
                    </div>
                      <div class="col-md-12 m-t-2">
                          <label for="" class="form-label">Dirección</label>
                          <input type="text" class="form-control" id="" placeholder="" v-model="registerForm.DatosPersonales.DireccionPersonal" required> 
                      </div>

                      <div class="col-md-12 d-flex justify-content-end">
                          <button type="submit" class="btn btn-light">Siguiente <i class="fas fa-arrow-right"></i></button>
                        </div>
                      </form>
                    </div>
                    <br>
                    <div class="col-md-8  bg-body rounded shadow-sm p-5" v-if="formulario == 2 && isLoad">
                      <form @submit.prevent="submit">
                        <h1 class="text-center">Editar datos laborales</h1>
                        <br>
 
                        <div class="col-md-12">
                         <label for="firstName" class="form-label">Profesión / Ocupación</label>
                         <input type="text" class="form-control" id="firstName" placeholder="" v-model="registerForm.DatosLaborales.Profesion" required>
                       </div>
                       
                       <div class="col-md-12 m-t-2">
                        <div class="form-check" v-for="(linea,index) in selectStatusLaboral" :key="index">
                          <input class="form-check-input" type="radio" name="flexRadioDefault" :id="linea.NombreParametroValor" :value="linea.Id" v-model="registerForm.DatosLaborales.StatusLaboral" @change="mostrarDatosLaborales">
                          <label class="form-check-label" :for="linea.NombreParametroValor" v-text="linea.NombreParametroValor">
                          </label>
                        </div>
                       </div>
                       <div v-if="registerForm.DatosLaborales.StatusLaboral!='TICL0003'">
                       <div class="col-md-12 m-t-2">
                        <label for="firstName" class="form-label">Empresa</label>
                        <input type="text" class="form-control" id="firstName" placeholder="" v-model="registerForm.DatosLaborales.Empresa" required>
                      </div>

                      <div class="col-md-12 m-t-2">
                        <label for="firstName" class="form-label">Cargo</label>
                        <input type="text" class="form-control" id="firstName" placeholder="" v-model="registerForm.DatosLaborales.Cargo" required>
                      </div>

                    
                    </div>
                    
                    <br>
 
                     <div class="col-md-12 d-flex justify-content-between">
                        <button type="button" class="btn btn-light" v-on:click="formulario -= 1"><i class="fas fa-arrow-left"></i> Volver </button>
                     </div>
                         <br>
                         <button class="w-100 btn btn-lg btn btn-registro" type="submit">Guardar cambios</button>
                      </form>
                     </div>
                </div>
            </div>
        </main>
    </div>
</template>


<script>
  import auth from '@/services/auth'
  import helpers from '@/services/helpers'
  
    export default {
      name: "EditarPerfil",
  
      data() {
      return {
        formulario:1,
        registerForm:{
          DatosPersonales:{
            Celular:"",
            PaisResidencia:"",
            Departamento:"",
            Provincia:"",
            Distrito:"",
            DireccionPersonal:"",
          },
          DatosLaborales: {
            Profesion: "",
            StatusLaboral: "",
            Empresa: "",
            Cargo: "",
        }
        },
        editForm:{
          EditarPerfil: {
            TelefonoCelular: "",
            PaisResidencia: "",
            Departamento: "",
            Provincia: "",
            Distrito: "",
            Direccion: ""
          },          
          EditarDatosLaborales: {
            Profesion: "",
            StatusLaboral: "",
            Empresa: "",
            Cargo: "",
            TiempoServicios: "",
            Direccion: "",
            TelefonoEmpresa: "",
            IngresoAnual: "",
            DeclJuradaOrigenFondo:[],
          }
        },
        selectPais:[],
        selectOrigenFondo:[],
        selectDepartamento:[],
        selectProvincia:[],
        selectDistrito:[],
        selectStatusLaboral:[],
        mostrarOtr: "0",
        isLoad:false,
      };
    },
  
    beforeCreate(){
      auth.editarCliente(this).then(response => {
        this.registerForm=response;
        auth.listParameters().then(response => {
          this.parametrosGenerales=response;
          this.obtenerSelectPais();
          this.obtenerSelectDepartamento();
          this.obtenerSelectProvincia();
          this.obtenerSelectDistrito();
          this.obtenerSelectStatusLaboral();
          this.esperarTiempo();
        });
      });
    },
    methods:{
      submit1(e) {
      this.formulario +=1;
    },
    async submit(e) {
      this.editForm.EditarPerfil.TelefonoCelular = this.registerForm.DatosPersonales.Celular;
      this.editForm.EditarPerfil.PaisResidencia = this.registerForm.DatosPersonales.PaisResidencia;
      this.editForm.EditarPerfil.Departamento = this.registerForm.DatosPersonales.Departamento;
      this.editForm.EditarPerfil.Provincia = this.registerForm.DatosPersonales.Provincia;
      this.editForm.EditarPerfil.Distrito = this.registerForm.DatosPersonales.Distrito;
      this.editForm.EditarPerfil.Direccion = this.registerForm.DatosPersonales.DireccionPersonal;
      this.editForm.EditarDatosLaborales.Profesion = this.registerForm.DatosLaborales.Profesion;
      this.editForm.EditarDatosLaborales.StatusLaboral = this.registerForm.DatosLaborales.StatusLaboral; 
      this.editForm.EditarDatosLaborales.Empresa = this.registerForm.DatosLaborales.Empresa;
      this.editForm.EditarDatosLaborales.Cargo = this.registerForm.DatosLaborales.Cargo;
      this.editForm.EditarDatosLaborales.TiempoServicios = this.registerForm.DatosLaborales.TiempoServicio;
      this.editForm.EditarDatosLaborales.Direccion = this.registerForm.DatosLaborales.DireccionLaboral;
      this.editForm.EditarDatosLaborales.TelefonoEmpresa = this.registerForm.DatosLaborales.TelefonoEmpresa;
      this.editForm.EditarDatosLaborales.IngresoAnual = this.registerForm.DatosLaborales.IngresoAnual;
      this.editForm.EditarDatosLaborales.DeclJuradaOrigenFondo = this.registerForm.DatosLaborales.DeclJuradaOrigenFondo;
      this.editForm.EditarDatosLaborales.OtrosEspecifico = this.registerForm.DatosLaborales.OtrosEspecifico;
      if (await auth.actualizarCliente(this)){
      }
      else{
      }
    },
    obtenerSelectPais(){
      this.selectPais=this.parametrosGenerales.ParametrosGeneralesUbigeo[0].Pais;
    },
    
    mostrarDatosLaborales(){
      if(this.registerForm.DatosLaborales.StatusLaboral!='TICL0003'){
      this.registerForm.DatosLaborales.Empresa="";
      this.registerForm.DatosLaborales.Cargo="";
      this.registerForm.DatosLaborales.TiempoServicio="";
      this.registerForm.DatosLaborales.DireccionLaboral="";
      this.registerForm.DatosLaborales.TelefonoEmpresa="";
      this.registerForm.DatosLaborales.IngresoAnual=""; 
    }
    },
    obtenerSelectDepartamento(){
      if(this.registerForm.DatosPersonales.PaisResidencia=="200"){
        this.selectDepartamento=this.parametrosGenerales.ParametrosGeneralesUbigeo[0].Departamento;
      }
      else{
        this.selectDepartamento="";
        this.selectProvincia="";
        this.selectDistrito="";
        this.registerForm.DatosPersonales. Departamento="";
        this.registerForm.DatosPersonales.Provincia="";
        this.registerForm.DatosPersonales.Distrito="";
      }
      },
      obtenerSelectProvincia(){
        this.selectProvincia=this.parametrosGenerales.ParametrosGeneralesUbigeo[0].Provincia.filter(e=>e.IdDepartamento==this.registerForm.DatosPersonales.Departamento);
        this.selectDistrito="";
      },
      obtenerSelectDistrito(){
        this.selectDistrito=this.parametrosGenerales.ParametrosGeneralesUbigeo[0].Distrito.filter(e=>e.IdProvincia==this.registerForm.DatosPersonales.Provincia);
      },
      obtenerSelectStatusLaboral(){
      this.selectStatusLaboral=this.parametrosGenerales.ParametrosGenerales.filter(e=>e.IdParametro=="TICL");
      this.selectOrigenFondo=this.parametrosGenerales.ParametrosGenerales.filter(e=>e.IdParametro=="DEOR");
    },
    soloNumeros($event){
          helpers.soloNumeros($event);
    },
    esperarTiempo() {
        setTimeout(function() {
            this.isLoad = true
        }.bind(this), 1000);
    }
    },
    };
    </script>


// WEBPACK FOOTER //
// src/components/user/EditarRegistro.vue